module.exports = __webpack_public_path__ + "img/time.b9a595c1.svg";